import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { palette } from '@leafygreen-ui/palette';
import Button, { ButtonProps } from '@leafygreen-ui/button';
import { Label, Body, Description } from '@leafygreen-ui/typography';

// utils
import { mq } from 'js/common/utils/mediaQueries';

// components
import LineDivider from 'js/common/components/LineDivider';

export const getLabelStyle = (isDisabled?: boolean) => css`
  color: ${isDisabled ? palette.gray.dark1 : palette.black};
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  margin-block-end: 0px;
`;

export const VercelLabel = styled(Label)`
  ${({ disabled }) => getLabelStyle(disabled)}
`;

export const VercelBodyLabel = styled(Body)<{ disabled?: boolean }>`
  ${({ disabled }) => getLabelStyle(disabled)}
`;

export const VercelDescription = styled(Description)`
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  margin-block-start: 0px;
  color: ${palette.gray.dark1};
  a {
    color: ${palette.blue.base};
    text-decoration: none;
  }
`;

export const VercelSubmitButton = styled<React.ComponentType<ButtonProps>>(Button)`
  margin: 24px 0px;
  width: 100%;
`;

export const containerStyle = css`
  margin: 24px auto 0;
  max-width: 524px;
`;

export const selectInputStyle = css`
  margin-top: 24px;

  label {
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    color: ${palette.black};
  }

  div {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    color: ${palette.gray.dark1};
  }

  button {
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    color: ${palette.gray.dark3};
  }
`;

export const VercelLineDivider = styled(LineDivider)(
  mq({
    width: '100%',
    margin: '16px 0',
  })
);
